var map = {
	"./aia.svg": 3011,
	"./ant.svg": 3012,
	"./aus.svg": 3013,
	"./bah.svg": 3014,
	"./ban.svg": 3015,
	"./bar.svg": 3016,
	"./ber.svg": 3017,
	"./biz.svg": 3018,
	"./bot.svg": 3019,
	"./bru.svg": 3020,
	"./can.svg": 3021,
	"./cay.svg": 3022,
	"./cmr.svg": 3023,
	"./cok.svg": 3024,
	"./cyp.svg": 3025,
	"./dma.svg": 3026,
	"./eng.svg": 3027,
	"./fij.svg": 3028,
	"./flk.svg": 3029,
	"./gab.svg": 3030,
	"./gam.svg": 3031,
	"./ggy.svg": 3032,
	"./gha.svg": 3033,
	"./gib.svg": 3034,
	"./grn.svg": 3035,
	"./guy.svg": 3036,
	"./ind.svg": 3037,
	"./iom.svg": 3038,
	"./ivb.svg": 3039,
	"./jam.svg": 3040,
	"./jey.svg": 3041,
	"./ken.svg": 3042,
	"./kir.svg": 3043,
	"./lca.svg": 3044,
	"./les.svg": 3045,
	"./manifest.json": 873,
	"./mas.svg": 3046,
	"./maw.svg": 3047,
	"./mdv.svg": 3048,
	"./mlt.svg": 3049,
	"./moz.svg": 3050,
	"./mri.svg": 3051,
	"./msr.svg": 3052,
	"./nam.svg": 3053,
	"./nfk.svg": 3054,
	"./ngr.svg": 3055,
	"./nir.svg": 3056,
	"./niu.svg": 3057,
	"./nru.svg": 3058,
	"./nzl.svg": 3059,
	"./pak.svg": 3060,
	"./png.svg": 3061,
	"./rsa.svg": 3062,
	"./rwa.svg": 3063,
	"./sam.svg": 3064,
	"./sco.svg": 3065,
	"./sey.svg": 3066,
	"./sgp.svg": 3067,
	"./shn.svg": 3068,
	"./skn.svg": 3069,
	"./sle.svg": 3070,
	"./sol.svg": 3071,
	"./sri.svg": 3072,
	"./svg-country.svg": 3073,
	"./swz.svg": 3074,
	"./tan.svg": 3075,
	"./tca.svg": 3076,
	"./tga.svg": 3077,
	"./tog.svg": 3078,
	"./tto.svg": 3079,
	"./tuv.svg": 3080,
	"./uga.svg": 3081,
	"./van.svg": 3082,
	"./wal.svg": 3083,
	"./zam.svg": 3084
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3010;